const privateEmailsIncludes = ['@gmail', '@yahoo', '@hotmail', '@outlook', '@msn', '@aol', '@icloud', '@live'];
export const isPrivateEmail = (email: string | undefined | null): boolean => {
    if (!email) {
        return false;
    }
    return privateEmailsIncludes.some((domain) => (email as string).includes(domain));
};
